import { C } from "../theme/colors";
import Section from "../components/Section";
import PageHero from "../components/PageHero";

export default function WayForwardPage() {
  const phases = [
    {phase:"Phase 1",label:"Foundation",color:C.navy,items:["Build infrastructure and induct domain expert members","Form an Advisory Board with senior stakeholders","Consolidate all ongoing national security-related research projects under CRENS"]},
    {phase:"Phase 2",label:"Launch",color:C.teal,items:["Initiate interaction and partnerships with various stakeholders","Identify and execute collaborative research projects","Launch initial certification courses for working professionals"]},
    {phase:"Phase 3",label:"Expansion",color:C.blue,items:["Expand partnerships nationally and internationally","Increase research projects based on stakeholder requirements","Scale up training programs with expanded curriculum"]},
    {phase:"Phase 4",label:"Growth",color:C.green,items:["Foster the growth of start-ups translating research into products","Secure additional funding from government and industry partners","Continuously evaluate and refine CRENS activities"]},
  ];
  return (
    <div className="page-fade">
      <PageHero title="Way Forward" tag="Strategic Roadmap" subtitle="A four-phase plan to build CRENS into India's premier national security research centre."/>
      <Section>
        <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:20}} className="grid-2">
          {phases.map((p,i) => (
            <div key={i} className="card" style={{padding:28,borderTop:`3px solid ${p.color}`}}>
              <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:20}}>
                <div style={{width:46,height:46,borderRadius:10,background:`${p.color}12`,border:`1.5px solid ${p.color}30`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontWeight:700,fontSize:15,color:p.color}}>{i+1}</span>
                </div>
                <div>
                  <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:18,fontWeight:700,color:C.navyDark}}>{p.phase}</div>
                  <div style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:10,color:p.color,letterSpacing:2,fontWeight:700,textTransform:"uppercase",marginTop:2}}>{p.label}</div>
                </div>
              </div>
              {p.items.map((item,j) => (
                <div key={j} style={{display:"flex",alignItems:"flex-start",gap:10,marginBottom:12}}>
                  <div style={{width:5,height:5,borderRadius:"50%",background:p.color,flexShrink:0,marginTop:7}}/>
                  <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,color:C.textMid,lineHeight:1.65}}>{item}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
